var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoanApplicationsInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.42 19.9998H6.01001V15.5898L19.01 2.58984L23.42 6.99982L10.42 19.9998ZM8.01001 17.9998H9.59003L20.59 6.99982L19.01 5.40979L8.01001 16.4098V17.9998Z",
    fill: "#4F4F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71719 14.2879L7.30298 15.7021L10.3011 18.7003L11.7153 17.2861L8.71719 14.2879Z",
    fill: "#4F4F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24H0V0H17V4H15V2H2V22H15V17H17V24Z",
    fill: "#4F4F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H4V6H12V4Z",
    fill: "#4F4F4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H4V10H9V8Z",
    fill: "#4F4F4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12H4V14H6V12Z",
    fill: "#4F4F4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanApplicationsInactive);
export default __webpack_public_path__ + "static/media/loan-applications-inactive.002449117996095ae43e2804588a6d3d.svg";
export { ForwardRef as ReactComponent };